<template>
  <div
    class="bubble text-body-2 font-weight-medium d-flex align-center justify-center"
    :class="classes"
  >
    <slot>
      {{ label }}
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Bubble',
  props: {
    color: {
      type: String,
      default: 'green accent-4',
    },
    textClass: {
      type: String,
      default: 'white--text',
    },
    label: {
      type: [String, Number],
      default: 1,
    },
  },
  computed: {
    classes() {
      return [
        this.color,
        this.textClass,
        {
          'double-digit': this.label && String(this.label).length > 1,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.bubble {
  width: 24px;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
}
.bubble.double-digit {
  font-size: 12px !important;
}
</style>
